module.exports = __webpack_public_path__ + "media/chess_move.3694dde6.mp3";